import Component from 'ember-notify/components/ember-notify/message';
export default Component;
